import useSharedStore from '@/presentation/store/shared';
import { getCookie } from '@/presentation/libs/cookie.lib';

const AUTH_ROUTES = ['auth-login', 'auth-otp', 'auth-signup', 'auth'];

const authMiddleware = (router) => {
	router.beforeEach((to, from) => {
		const sharedStore = useSharedStore();
		const token = getCookie('access-token');
		const refreshToken = getCookie('refresh-token');

		if (AUTH_ROUTES.includes(to.name as string) && token && refreshToken) {
			return '/';
		}

		const requiresAuth = to.meta?.requiresAuth;

		if (requiresAuth && !token && !refreshToken) {
			sharedStore.redirectPathAfterLogin = to.fullPath;
			return '/auth/login';
		}
		return true;
	});
};

export default authMiddleware;
